import {Locales} from '@netx/core-next/locales/utils/Locales';

export const UserGroupAutoListLabel = Locales((i18n) => ({
	INPUT: i18n(`i18n.addUserOrGroup`),
	PLACEHOLDER: i18n(`i18n.pleaseSelect`),
}));
